<template>
  <div class="idf-info-card" :class="computeClassKind()">
    <adn-message :title="title" :kind="kind" :icon="icon">
      <slot></slot>
    </adn-message>
  </div>
</template>

<script>
import AdnMessage from '../AdnMessage/AdnMessage.vue'

export default {
  name: 'IdfInfoCard',
  components: {
    AdnMessage,
  },
  props: {
    title: {
      type: String,
    },
    kind: {
      type: String,
      default: 'info',
    },
    icon: {
      type: String,
    },
  },
  setup(props) {
    const computeClassKind = () => {
      return `kind-${props.kind}`
    }
    return { computeClassKind }
  },
}
</script>
<style scoped lang="scss">
.idf-info-card {
  background: var(--color-background-light);
  border-radius: var(--border-radius-m);
  box-shadow: var(--shadow);
  border-left: var(--border-radius-m) solid var(--color-background-light);
}

.kind-warning {
  border-left-color: var(--color-warning);
}

.kind-danger {
  border-left-color: var(--color-error);
}

.kind-success {
  border-left-color: var(--color-success);
}

.kind-info {
  border-left-color: var(--color-text-light);
}

:deep(.adn-message) {
  background: transparent;
}
</style>
